





































































































































































import { Vue, Component } from 'vue-property-decorator';
import { mapState } from 'vuex';

import { objectIsEmpty } from '~/utils/common.js';
import { replaceUrl } from '~/utils/explorer.js';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';
import EventCategoryTag from '~/components/partials/EventCategoryTag.vue';
import PinOutline from '~/components/icons/PinOutline.vue';
import PlaySolid from '~/components/icons/PlaySolid.vue';
import ExternalOutline from '~/components/icons/ExternalOutline.vue';
import RelatedDestinationItem from '~/components/lists/items/RelatedDestinationItem.vue';
import TouristFeed from '~/components/lists/TouristFeed.vue';
import PhoneOutline from '~/components/icons/PhoneOutline.vue';
import RespectCard from '~/components/cards/RespectCard.vue';
import Breadcrumb from '~/components/partials/Breadcrumb.vue';
import MailOutline from '~/components/icons/MailOutline.vue';

@Component({
  components: {
    ChevronRightSolid,
    EventCategoryTag,
    PinOutline,
    PlaySolid,
    ExternalOutline,
    RelatedDestinationItem,
    TouristFeed,
    PhoneOutline,
    RespectCard,
    Breadcrumb,
    MailOutline,
  },
  middleware: ['noauth'],
  computed: {
    ...mapState('explorer', [
      'touristOffice',
      'destination',
      'destinationTourists',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
  head () {
    const self: any = this;
    const description = self.touristOffice.description?.trim().replace(/<\/?[^>]+(>|$)/g, "");
    const locale: string = self.$store.state.lang.locale;

    return {
      title: `${self.touristOffice.title} - On Piste`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: description,
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: `${self.touristOffice.title} - On Piste`,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: self.touristOffice.media?.length ? self.$thumbnailUrl(self.touristOffice.media[0], 1200) : 'https://www.onpiste.com/img/placeholders/provider-placeholder.png',
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://www.onpiste.com/${locale === 'fr' ? '' : `${locale}/`}explorer/tourist-offices/${self.$slugify(self.touristOffice.title)}-${self.touristOffice.id}`,
        },
      ],
    };
  },
  async fetch () {
    const self: any = this;
    await self.populateDestinationDatas();
  },
  async asyncData ({ store, route, error, app }) {
    const errorInstance: any = error;

    if (
      route.params.touristid.split('-').pop() === '' ||
      isNaN(Number(route.params.touristid.split('-').pop()?.trim()))
    ) {
      return errorInstance({
        statusCode: 404,
        response: { data: { detail: 'Unknown tourist_office' } },
      });
    }

    try {
      if (route.query?.preview) {
        await store.dispatch('explorer/getTouristOfficePreview', {
          id: route.params.touristid.split('-').pop()?.trim(),
          token: route.query.preview,
          lang: store.state.lang.locale,
        });
      } else {
        await store.dispatch('explorer/getTouristOffice', {
          id: route.params.touristid.split('-').pop()?.trim(),
          lang: store.state.lang.locale,
        });
      }
    } catch (e) {
      return errorInstance({
        statusCode: e.response.status,
        response: { data: { detail: app.i18n.t(e.response.data.detail) } },
      });
    }
  },
})
export default class ProviderId extends Vue {
  touristOffice: Types.TourismOffice;
  destinationTourists: Types.TourismOffice[];
  destination: Types.DestinationItem;
  locale: string;

  hashtags: Array<string> = ['Rossignol', 'On Piste'];

  /* Returns reactive array of breadcrumb links containing some store values */
  get breadcrumbMenu () {
    return [
      { path: '/', name: this.$t('explorer.tourist.breadcrumb.home') },
      { path: '/explorer', name: this.$t('explorer.tourist.breadcrumb.explorer') },
      this.destinationIsEmpty ? { path: ``, name: this.$t('explorer.destinations.unpublished') } : { path: `/explorer/destinations/${this.$slugify(`${this.destination.title}-${this.destination.id}`)}`, name: this.destination.title },
      { path: '', name: this.touristOffice?.title, isActive: true },
    ];
  }

  /* Returns reactive submenu links that contains some store values */
  get subMenuLinks () {
    return [
      {
        link: '#description',
        name: this.$t('explorer.tourist.submenu.description'),
        isDisplayed: true,
      },
      {
        link: '#similar-tourists',
        name: this.$t('explorer.tourist.submenu.similar'),
        isDisplayed: this.destinationTourists.length > 0,
      },
    ];
  };

  /* Computed skeleton handle */
  get destinationIsEmpty () {
    return objectIsEmpty(this.destination);
  }

  /* Computed skeleton handle */
  get touristIsEmpty () {
    return objectIsEmpty(this.touristOffice);
  }

  mounted () {
    window.dataLayer.push({
      'Destination': this.destination.title,
      'DestinationID': this.destination.id,
    });

    /*
      Using util method to adapt URL to a specific format containing title and
      ID of retrieved element for better SEO.
    */
    replaceUrl(
      this.$route.params.touristid,
        `${this.locale !== 'fr' ? `/${this.locale}` : ''}/explorer/tourist-offices/${this.$slugify(this.touristOffice.title)}`,
        this.$slugify(this.touristOffice?.title),
    );
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/provider-placeholder.png";
  }

  /*
    In SSR mode this method is called in fetch, before the page mounts.
    The tmeplate wil be rendered with datas of element.
  */
  async populateDestinationDatas () {
    await this.$store.dispatch('explorer/getDestination', {
      id: this.touristOffice.destination_id,
      lang: this.locale,
    });

    await this.$store.dispatch('explorer/getTouristsSimilar', {
      id: this.touristOffice.id,
      lang: this.locale,
    });
  }

  // redirectToExplorer (tag: Types.SportItem) {
  //   const route: any = this.localePath(`/explorer?sport=${tag.id}`);
  //   this.$router.push(route);
  // }
}
